import { Member, Organization } from '@ui/interfaces'
import axios from '@ui/lib/api/axiosHelper'

/*
************************************************************
CONSTANTS
************************************************************
*/
const ORGS_URL = '/v1/organizations'

/*
************************************************************
TYPES
************************************************************
*/
export interface OrganizationData {
  status: string
  statusText: string
  data: Organization
}

export interface CreateOrganizationInput {
  name: string
}

export interface CreateMemberInput {
  email: string
  first_name: string
  last_name: string
  role: string
}

interface OrgService {
  fetchMembers: (orgId: string) => Promise<Member[]>
  removeMember: (orgId: string, memberId: number) => Promise<void>
  createMember: (orgId: string, data: CreateMemberInput) => Promise<Member>
}

/*
************************************************************
SERVICES
************************************************************
*/
export const orgService: OrgService = {
  createMember: async (orgId: string, data: CreateMemberInput) => {
    try {
      const response = await axios.post(`${ORGS_URL}/${orgId}/members`, data)
      return response.data
    } catch (error) {
      console.error('Failed to create member for organization', orgId, error)
      throw error
    }
  },
  fetchMembers: async (orgId: string) => {
    try {
      const response = await axios.get(`${ORGS_URL}/${orgId}/members`)
      return response.data
    } catch (error) {
      console.error('Failed to fetch members for organization', orgId, error)
      throw error
    }
  },
  removeMember: async (orgId: string, memberId: number) => {
    try {
      await axios.delete(`${ORGS_URL}/${orgId}/members/${memberId}`)
    } catch (error) {
      console.error('Failed to remove member from organization', orgId, memberId, error)
      throw error
    }
  },
}
